export default function ShareButton({ text, link }) {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Racemood",
          text: text ?? "Guarda questo sito di elaborazioni auto!",
          url: link ?? window.location.href,
        });
      } catch (err) {}
    } else {
      console.log("La condivisione nativa non è supportata su questo dispositivo.");
    }
  };

  return (
    <button
      onClick={handleShare}
      style={{
        padding: "7px 10px",
        border: "none",
        borderRadius: "8px",
      }}
    >
      <i className="fas fa-share-alt"></i>
    </button>
  );
}
